<div class="container">

  <div class="loader" *ngIf="loading"></div>

  <div *ngIf="mode == 'EDIT' && !loading" class="animated fadeIn">
    <nav class="navbar navbar-light bg-light fixed-top mt-fixed-top">
      <div class="container">
        <span class="navbar-text">
          Parámetros de Configuración
        </span>
        <div class="pull-right">
          <button class="btn btn-link" (click)="cancelEvent()">
            Cerrar
          </button>
          <button class="btn btn-primary" (click)="saveEvent()">
            Guardar
          </button>
        </div>
      </div>
    </nav>

    <div class="row g-3">
      <div class="col-md-6">
        <label for="code">Código</label>
        <select class="form-select" id="code" name="code" [(ngModel)]="model.code">
          <option *ngFor="let c of codes" [value]="c.value">{{c.label}}</option>
        </select>
        <div *ngIf="formErrors.get('configurationparameter.code')" class="badge bg-danger animated fadeIn">
          {{ formErrors.get('configurationparameter.code') }}
        </div>
      </div>
      <div class="col-md-6">
        <label for="value">Valor</label>
        <input type="number" class="form-control" id="value" name="value" [(ngModel)]="model.value">
        <div *ngIf="formErrors.get('configurationparameter.value')" class="badge bg-danger animated fadeIn">
          {{ formErrors.get('configurationparameter.value') }}
        </div>
      </div>
      <div class="col-md-6">
        <label for="effectiveStart">Fecha de Inicio</label>
        <mt-date-picker [(date)]="model.effectiveStart" name="effectiveStart" id="effectiveStart" label="Fecha de Inicio"/>
        <div *ngIf="formErrors.get('configurationparameter.effectiveStart')" class="badge bg-danger animated fadeIn">
          {{ formErrors.get('configurationparameter.effectiveStart') }}
        </div>
      </div>
      <div class="col-md-6">
        <label for="effectiveEnd">Fecha Fin</label>
        <mt-date-picker [(date)]="model.effectiveEnd" name="effectiveEnd" id="effectiveEnd" label="Fecha Fin"/>
        <div *ngIf="formErrors.get('configurationparameter.effectiveEnd')" class="badge bg-danger animated fadeIn">
          {{ formErrors.get('configurationparameter.effectiveEnd') }}
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="mode == 'LIST' && !loading" class="animated fadeIn">

    <nav class="navbar navbar-light bg-light fixed-top mt-fixed-top">
      <div class="container-fluid">
        <div class="pull-right">
          <button type="button" class="btn btn-secondary pull-right ms-2" (click)="refreshEvent()" title="Refrescar">
            <span class="fa fa-sync fa-lg"></span>
          </button>
          <button type="button" class="btn btn-primary pull-right ms-2" (click)="createEvent()">
            Nuevo
          </button>
        </div>
      </div>
    </nav>

    <mt-pagination (loadPage)="getPageEvent($event)" [page]="page"></mt-pagination>

    <table *ngIf="page.metadata.pages > 0" class="table table-hover">
      <thead>
        <tr>
          <th>Código</th>
          <th>Valor</th>
          <th>Inicio</th>
          <th>Fin</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
      <tr *ngFor="let config of page.content">
        <td (click)="editEvent(config)" class="mt-content-col">
          <strong>{{getCodeLabel(config.code)}}</strong>
        </td>
        <td (click)="editEvent(config)" class="mt-content-col">
          {{config.value}}
        </td>
        <td (click)="editEvent(config)" class="mt-content-col">
          {{config.effectiveStart}}
        </td>
        <td (click)="editEvent(config)" class="mt-content-col">
          {{config.effectiveEnd}}
        </td>
        <td class="mt-actions-col">
          <button class="btn btn-danger pull-right me-1" data-bs-toggle="modal"
                  data-bs-target="#removeConfigConfirmation"
                  (click)="selectEvent(config)" title="Borrar">
            <span class="fa fa-trash-alt fa-lg"></span>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <div *ngIf="page.metadata.pages == 0">
      No hay registros
    </div>

  </div>

  <!-- Modal -->
  <div class="modal fade" id="removeConfigConfirmation" tabindex="-1" role="dialog"
       aria-labelledby="removeConfirmationLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Confirmar</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>Desea eliminar el registro?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-bs-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="removeEvent(model)">Borrar
          </button>
        </div>
      </div>
    </div>
  </div>

</div>
